import Vue from 'vue';

// ANT DESIGN
import { Avatar, Rate, Breadcrumb, InputNumber, Steps, message, Upload, Button, Layout, Table, Icon, Progress, Radio, Dropdown, Menu, Carousel, Input, Calendar, Badge, Slider, Form, Tooltip, Select, Switch, Tag, Affix, Spin, Alert, Checkbox, Tabs, Pagination, notification, Drawer, Cascader, DatePicker, TimePicker, Divider, Popconfirm, Modal, Skeleton, AutoComplete, Popover } from 'ant-design-vue';

// STYLES
// import 'ant-design-vue/lib/style/index.less'; // antd core styles
import '@/system/assets/styles/vendors/antd/themes/default'; // default theme antd components
import '@/system/assets/styles/vendors/antd/themes/dark'; // dark theme antd components
import '@/system/assets/styles/global';
import 'animate.css/animate.css';

Vue.use(Avatar);
Vue.use(Divider);
Vue.use(Button);
Vue.use(Rate);
Vue.use(Breadcrumb);
Vue.use(Layout);
Vue.use(Table);
Vue.use(Icon);
Vue.use(Progress);
Vue.use(Radio);
Vue.use(Dropdown);
Vue.use(Menu);
Vue.use(Carousel);
Vue.use(Input);
Vue.use(Calendar);
Vue.use(Badge);
Vue.use(Slider);
Vue.use(Form);
Vue.use(Tooltip);
Vue.use(Select);
Vue.use(Tag);
Vue.use(Affix);
Vue.use(Spin);
Vue.use(Alert);
Vue.use(Checkbox);
Vue.use(Tabs);
Vue.use(Pagination);
Vue.use(Upload);
Vue.use(message);
Vue.use(Steps);
Vue.use(InputNumber);
Vue.use(Drawer);
Vue.use(Switch);
Vue.use(Cascader);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(notification);
Vue.use(Popconfirm);
Vue.use(Modal);
Vue.use(Skeleton);
Vue.use(AutoComplete);
Vue.use(Popover);

Vue.prototype.$notification = notification;
Vue.prototype.$message = message;
Vue.prototype.$info = Modal.info;
